
<div class="panel-body">

  <form #f="ngForm"
        novalidate (ngSubmit)="save(f)">
    <div class="row padding-sm-vr">
      <div class="col-sm-12">

        <label class="control-label">{{'Business Units' |translate}} </label>
        <span class="ui-fluid">
          <p-dropdown [options]="businessUnits"
                      placeholder="{{'Business Units' | translate}}"
                      emptyFilterMessage="No results found"
                      showClear="true"
                      styleClass="wid100"
                      name="itemBrandId"
                      #itemBrandId="ngModel"
                      [(ngModel)]="hcpBrandsClass.businessUnit"
                      (onChange)="onChangeBu()"
                      [filter]="true" optionLabel="name">
          </p-dropdown>
        </span>
      </div>
    </div>
    <div class="row padding-sm-vr">
      <div class="col-sm-12">
        <label class="control-label">{{'labels.class' |translate}} </label>
        <span class="ui-fluid">
          <p-dropdown [options]="filteredClasses"
                      placeholder="{{'labels.class' |translate}}"
                      emptyFilterMessage="{{'app.noDataFound' |translate}}"
                      showClear="true"
                      styleClass="wid100"
                      #hcoClass="ngModel"
                      name="hcoClass"
                      [(ngModel)]="hcpBrandsClass.class"
                      [filter]="true" optionLabel="name">

          </p-dropdown>
        </span>

      </div>





    </div>
    <div class="row padding-sm-vr">
      <div class="col-sm-6">
        <label class="control-label">{{'hco.startDate' | translate}} *</label>
        <input type="text" name="classStartDate" [(ngModel)]="hcpBrandsClass.startDate" required="required" #classStartDate="ngModel"
               bsDatepicker [maxDate]="maxDate" [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}"
               class="form-control" autocomplete="off" />
        <div *ngIf="(classStartDate.dirty || classStartDate.touched || f.submitted) && classStartDate.invalid" class="jquery-validate-error help-block">
          {{'hco.classStartDateRequired' | translate}}
        </div>
      </div>
      <div class="col-sm-6">
        <label class="control-label">{{'hco.endDate' | translate}}</label>
        <input type="text" name="classEndDate" [(ngModel)]="hcpBrandsClass.endDate"
               bsDatepicker [maxDate]="maxDate" [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}"
               class="form-control" autocomplete="off" placeholder="{{'hco.current' | translate}}" />
        <small class="text-muted">{{'hco.endDateHint' | translate}}</small>
      </div>
    </div>
    <div class="panel-footer margin-left-20 margin-top-20 margin-left-20">
      <button class="btn  btn-cancel" type="button" (click)="close()">{{'app.cancel' | translate}}</button>&nbsp;
      <button class="btn  btn-save" type="submit">{{'app.save' | translate}}</button>
    </div>
  </form>

</div>

